var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPmrGrayBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C73167AD-ACF2-4076-B89F-A49F3B4BE578") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gu\\xEDa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconos",
    transform: "translate(-78.000000, -689.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMR_No-Asignado",
    transform: "translate(78.000000, 689.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMR_no-asignado"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#D7DBE4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.500000, 7.500000) rotate(-315.000000) translate(-7.500000, -7.500000) translate(6.500000, 4.500000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0,
    x2: 1,
    y2: 6,
    id: "Path-2"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmrGrayBig);
export default __webpack_public_path__ + "static/media/pmr-gray-big.ad835785.svg";
export { ForwardRef as ReactComponent };